import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AppPrincipal, isAnonymousViewer } from '../auth/AppPrincipal';
import { AlertPresenter } from '../AlertPresenter';
import { AuthHandler } from '../auth/AuthHandler';
import { ISignInTrackingFrom } from '../auth/ISignInTrackingFrom';

export class LoginNudgeAlert {
    static inject = () => [
        AlertPresenter,
        AuthHandler
    ];

    constructor(
        private alert: AlertPresenter,
        private authHandler: AuthHandler
    ) {};

    show = async ({
        trackingFrom,
        message,
        redirect
    }: {
        trackingFrom: ISignInTrackingFrom;
        message?: string;
        redirect?: string;
    }) => {
        const action = await this.alert.showAlertV2({
            header: 'Sign-In Required',
            message: message || 'You must sign in to use this functionality.',
            options: [{
                id: 'cancel',
                role: 'cancel',
                label: 'Not Now'
            }, {
                id: 'continue',
                label: 'Continue'
            }]
        });

        if (action === 'continue'){
            await this.authHandler.login({ trackingFrom, returnTo: redirect });
        }
    };
};

export const useIfLoggedIn = () => {
    const isAnonymous = isAnonymousViewer(useInstance(AppPrincipal));
    const loginNudge = useInstance(LoginNudgeAlert);

    return async ({
        delegate,
        trackingFrom,
        unathenticatedDelegate,
        message,
        redirect
    }: {
        delegate: () => void;
        trackingFrom: ISignInTrackingFrom;
        unathenticatedDelegate?: () => void;
        message?: string;
        redirect?: string;
    }) => {
        if (isAnonymous) {
            if (unathenticatedDelegate) {
                unathenticatedDelegate();
            }
            await loginNudge.show({ message, redirect, trackingFrom });
        } else {
            delegate();
        }
    };
};
